import * as z from "zod";
import {DEFAULT_MANAGER_INFORMATION, ManagerInformationModel} from "../../tax-corporation";
import {CustomerRecommendationModel} from "./CustomerRecommendationModel";
import {TaxAccountantRecommendationModel} from "./TaxAccountantRecommendationModel";

const schema = z.object({
	managerInformation: ManagerInformationModel.model,
	taxAccountantRecommendations: z.array(TaxAccountantRecommendationModel.model),
	customerRecommendations: z.array(CustomerRecommendationModel.model),
	customerManagements: z.array(CustomerRecommendationModel.model),
	taxAccountantCount: z.object({
		recommendedTaxAccountantCount: z.number(),
		taxAccountantCount: z.number()
	}),
	customerManagementCount: z.object({
		customerCount: z.number(),
		taxAccountantCount: z.number()
	}),
	customerRecommendationCount: z.object({
		customerCount: z.number(),
		taxAccountantCount: z.number()
	})
});

const model = schema.transform((values) => ({
	...values
}));

export const ManagerSummaryModel = {schema, model};
export type IManagerSummaryModel = z.infer<typeof ManagerSummaryModel.model>;
export const DEFAULT_MANAGER_SUMMARY: IManagerSummaryModel = {
	managerInformation: DEFAULT_MANAGER_INFORMATION,
	taxAccountantRecommendations: [],
	customerRecommendations: [],
	customerManagements: [],
	taxAccountantCount: {recommendedTaxAccountantCount: 0, taxAccountantCount: 0},
	customerManagementCount: {customerCount: 0, taxAccountantCount: 0},
	customerRecommendationCount: {customerCount: 0, taxAccountantCount: 0}
};
